import styled, { css } from 'styled-components'
import MapSearchButton from 'Components/MapSearchButton'
import { BREAK_POINT_SM } from '@CSSVars/variables'

import { HYPER_LINK_COLOR, FONT_BASE_COLOR } from '@CSSVars/colors'


export const collapseContainerCss = css`
  margin-bottom: 128px;

  h2 {
    font-size: 20px;
    line-height: 22px;
  }
`

export const collapseContentCss = css`
  @media screen and (max-width: 767px) {
    margin-top: 16px;
  }
`

export const _MapPreviewsContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  min-height: 300px;
  flex-direction: column;
  height: auto;
`


export const _MapSearchButton = styled(MapSearchButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  width: 100%;
  margin-top: 24px;
  background-color: ${HYPER_LINK_COLOR};
  cursor: pointer;
  border-radius: 10px;

  span {
    text-transform: none;
  }

  @media screen and (max-width: ${BREAK_POINT_SM}) {
    background: white;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
    width: 190px;
    span {
      color: ${FONT_BASE_COLOR};
      font-size: 12px;
      line-height: 22px;
      font-weight: 600;
    }
  }
`

export const _Text = styled.span`
  color: white;
`

export const _NoListings = styled.div`
  margin-top: 100px;
  height: 100%;
`
